import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 1.1, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block"
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.15, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const Divider = ({ dark = false }) => (
    <div className="flex items-center justify-center gap-3" data-testid="gold-divider">
        <span className={`h-px w-14 ${dark ? "bg-champagne/70" : "bg-champagne"}`} />
        <span className="block h-1.5 w-1.5 rotate-45 bg-champagne" />
        <span className={`h-px w-14 ${dark ? "bg-champagne/70" : "bg-champagne"}`} />
    </div>
);
